<template :class="$style['adl-non-super']">
  <mds-modal
    size="large"
    :width="'600px'"
    aria-label="Large Modal"
    v-model="hasOpenModel"
    title=""
    action-required
  >
    <adl-editable-grid
      :filterInfo="baselineData.filterInfo"
      :headers="baselineData.headers"
      :rows="rows"
      :infoText="baselineData.infoText"
      :singleHeading="baselineData.singleHeading"
      :singleHeadingButtonText="baselineData.singleHeadingButtonText"
      :singleHeadingOptions="singleHeadingOptions"
      :gridSplitId="baselineData.gridSplitId"
      :isShowHint="baselineData.isShowHint"
      :focusElementName="baselineData.focusElementName"
      :infoError="baselineData.infoError"
      :rowTemplateButton="baselineData.rowTemplateButton"
      :gridButtonTemplate="gridButtonTemplate"
      :emptyGridData="baselineData.emptyGridData"
      :nonSuperFilterObject="nonSuperFilterObject"
      @buttonclick="genericMethodClick"
      @editableRowButtonClick="genericMethodClick"
      @onChange="onChange"
    >
      <template v-slot:message>
        <p class="cf-message-helper">
          Non superannuation values entered do not reflect in the projection.
          They are <strong>used to calculate</strong> the Income and Asset Test
          for <strong>Age Pension</strong> only.
        </p>
      </template>
    </adl-editable-grid>
  </mds-modal>
</template>
<script>
import { AdlEditableGrid } from "../../component/tool";
import MdsModal from "@mds/modal";
import { SuperannuationAdvanceFilterContent } from "../../mixin";
import {
  GET_SELECTED_SUPERANNUATION_INFORMATION,
  GET_SUPERANNUATION_INFORMATION,
  GET_RISK_PROFILE_DATA,
  GET_AUTH_INFORMATION,
  GET_CLIENT_INFORMATION,
} from "../../helpers/vuex-constants";
import { mapGetters } from "vuex";
import _ from "lodash";
import { CommonHelper } from "../../helpers";
import { EntityTypes } from "../../helpers/constant";
export default {
  props: {
    isopenModel: {
      type: Boolean,
    },

    nonSuperFilterObject: {
      type: Array,
    },
  },
  components: {
    MdsModal,
    AdlEditableGrid,
  },
  data() {
    return {
      hasOpenModel: this.isopenModel,
      selectedComponent: "superannuation-nonSuper-tool",

      baselineData: {
        emptyGridData: {
          title: "",
          message: "",
          imagepath: "../../assets/icons/dollar.svg",
          buttonVisible: true,
          list: [],
        },

        filterInfo: {
          title: "Non Super",
          borderPosition: "bottom",
          actionButtons: [
            {
              method: "closeNonSuper",
              variation: "secondary",
              text: "Cancel",
              id: "2",
            },
            {
              method: "applyNonSuper",
              variation: "primary",
              text: "Apply Changes",
              id: "1",
            },
          ],
        },
        singleHeading: "",
        headers: [
          {
            type: "FormatInput",
            label: "Current Value",
            cols: 2,
            key: "currentValue",
            isAllowOnlyNumber: true,
            appendText: "",
            currencyFormat: "$,",
            max: 999999999,
            length: 9,
            validation: false,
            style: {
              width: "120px",
            },
          },
          {
            type: "FormatInput",
            label: "Income Return",
            cols: 2,
            key: "incomeReturn",
            isAllowOnlyNumber: true,
            AllowOnlyDecimalTill: 2,
            currencyFormat: "",
            appendText: "%",
            length: 5,
            max: 99.99,
            validation: false,
          },
          {
            type: "FormatInput",
            label: "Growth Return",
            cols: 2,
            key: "growthReturn",
            isAllowOnlyNumber: true,
            AllowOnlyDecimalTill: 2,
            currencyFormat: "",
            appendText: "%",
            length: 5,
            max: 99.99,
            validation: false,
          },
          {
            type: "FormatInput",
            label: "Contribution",
            cols: 2,
            key: "contribution",
            isAllowOnlyNumber: true,
            appendText: "",
            currencyFormat: "$,",
            max: 999999999,
            length: 9,
            validation: false,
            style: {
              width: "120px",
            },
          },
        ],
        rowOuterButton: [],
        focusElementName: "",
        rowTemplateButton: [],
        infoText: [""],
        infoError: false,
        singleHeadingButtonText: "",
        gridSplitId: "nonSuperType",
        isShowHint: true,
        rows: [],
        singleHeadingOptions: [],
      },
      singleHeadingOptions: [],
      rows: [],
      gridButtonTemplatedata: [
        {
          size: "medium",
          variation: "secondary",
          isdisabled: true,
          text: "Reset",
          callBackMethod: "reset",
          key: "reset",
        },
      ],
    };
  },
  mixins: [SuperannuationAdvanceFilterContent],
  mounted() {
    
    (this.singleHeadingOptions = [
      {
        key: 1,
        value: "Investment",
        fields: [
          "currentValue",
          "incomeReturn",
          "growthReturn",
          "contribution",
        ],
        overlapvalidations: false,
      },
    ]),
      (this.rows = this.fillGrid());
  },
  async created() {},
  computed: {
    ClientInformation() {
      return this.getClientInformation.filter(
        (x) => x.entityType == EntityTypes.client
      );
    },
    ...mapGetters("superannuation", {
      selectedSuperannuationData: GET_SELECTED_SUPERANNUATION_INFORMATION,
      getSuperannuationInformation: GET_SUPERANNUATION_INFORMATION,
    }),
    ...mapGetters({
      getRiskProfileData: GET_RISK_PROFILE_DATA,
      getAuthInformation: GET_AUTH_INFORMATION,
      getClientInformation: GET_CLIENT_INFORMATION,
    }),
    gridButtonTemplate() {
      return this.EnableDisableResetButton();
    },
  },
  methods: {
    onChange() {
      this.EnableDisableResetButton();
    },
    EnableDisableResetButton() {
      let difference = true;
      let Superannuations = this.getSuperannuationInformation.filter(
        (sr) =>
          sr.superFundGuid == this.selectedSuperannuationData.superFundGuid
      );
      let ExistingData = Superannuations[0].nonSuperData.map(function (t) {
        let p = {};
        p.currentValue = t.currentValue;
        p.incomeReturn = t.incomeReturn;
        p.growthReturn = t.growthReturn;
        p.contribution = t.contribution;
        return p;
      });

      let CurrentDataObject = [];
      let SelectedDefaultData = this.selectedSuperannuationData;
      for (let i = 0; i < this.rows.length; i++) {
        if (ExistingData.length == 0) {
          ExistingData = CommonHelper.ConvertObjectIntoApiModel(
            this.getDefaultModel()
          );
          delete ExistingData[0].nonSuperType;

          SelectedDefaultData.nonSuperData.map(function (t) {
            let p = {};
            p.currentValue = t.currentValue;
            p.incomeReturn = t.incomeReturn;
            p.growthReturn = t.growthReturn;
            p.contribution = t.contribution;
            return p;
          });
        }
        CurrentDataObject.push({
          currentValue: this.rows[i].currentValue.value,
          incomeReturn: this.rows[i].incomeReturn.value,
          growthReturn: this.rows[i].growthReturn.value,
          contribution: this.rows[i].contribution.value,
        });
      }
      if (ExistingData.length > 0) {
        difference = _.isEqual(ExistingData, CurrentDataObject);
      } else {
        difference = _.isEqual(ExistingData, CurrentDataObject);
      }

      this.enableResetButton(difference, "reset");

      return this.gridButtonTemplatedata;
    },
    fillGrid() {
      let gridRows = [];
      let data = this.nonSuperFilterObject;
      if (data != null && data.length > 0) {
        gridRows = this.emptyGridRow(data);
      }
      this.getinsertEmptyRows(gridRows);
      return gridRows;
    },
    getinsertEmptyRows(currentRows) {
      for (let i = 0; i < this.singleHeadingOptions.length; i++) {
        if (
          currentRows.filter(
            (x) => x.nonSuperType.value == this.singleHeadingOptions[i].key
          ).length == 0
        )
          currentRows.push(
            this.fillData(undefined, this.singleHeadingOptions[i].key)
          );
      }
    },
    emptyGridRow(data) {
      if (data == undefined) {
        return this.fillData();
      } else {
        let gridData = [];
        for (let i = 0; i < data.length; i++) {
          gridData.push(this.fillData(data[i]));
        }
        return gridData;
      }
    },
    fillData(data, nonSuperType = 0) {
      let IsDataundfined = data == undefined;
      if (nonSuperType == 0 && !IsDataundfined) {
        nonSuperType = data.nonSuperType.value;
      }

      let emptyArray = {
        currentValue: {
          value: IsDataundfined ? "0" : data.currentValue.value,
        },
        incomeReturn: {
          value: IsDataundfined ? "0" : data.incomeReturn.value,
        },
        growthReturn: {
          value: IsDataundfined ? "0" : data.growthReturn.value,
        },
        contribution: {
          value: IsDataundfined ? "0" : data.contribution.value,
        },
        nonSuperType: {
          value: IsDataundfined ? nonSuperType : data.nonSuperType.value,
        },
      };
      return emptyArray;
    },

    genericMethodClick(function_name) {
      this[function_name]();
    },
    closeNonSuper() {
      this.$emit("closeModel");
    },
    async applyNonSuper() {
      this.selectedComponent = "superannuation-nonSuper-tool";
      this.$emit("applyChangesNonSuper", this.rows);
    },
    GetRowData(selectedRepData) {
      let advanceData = [];
      advanceData.push({
        currentValue: {
          value: selectedRepData[0].currentValue,
        },
        incomeReturn: {
          value: selectedRepData[0].incomeReturn,
        },
        growthReturn: {
          value: selectedRepData[0].growthReturn,
        },
        contribution: {
          value: selectedRepData[0].contribution,
        },
        nonSuperType: {
          value: selectedRepData[0].nonSuperType,
        },
      });
      return advanceData;
    },
    getDefaultModel() {
      let defaultData = _.cloneDeep(
        this.getSuperannuationInformation.filter(
          (x) =>
            x.superFundId == this.selectedSuperannuationData.superFundId &&
            x.superFundGuid == this.selectedSuperannuationData.superFundGuid
        )[0]
      );
      let nonSuperData = [];
      let defaultriskprofiles = this.getRiskProfileData.defaultriskprofiles;
      let riskprofiles = CommonHelper.getClientRiskProfileModel(
        defaultriskprofiles,
        this.ClientInformation[0].clientId
      );
      nonSuperData = CommonHelper.GetNonSuperDefaultRiskProfileModel(
        riskprofiles,
        defaultData.otherDetail.nonSuperBalance
      );

      return nonSuperData;
    },
    reset() {
      let Superannuations = this.getSuperannuationInformation.filter(
        (sr) =>
          sr.superFundGuid == this.selectedSuperannuationData.superFundGuid
      );
      let selectedRepData = Superannuations[0].nonSuperData;
      if (selectedRepData.length > 0) {
        this.rows = this.GetRowData(selectedRepData);
      } else {
        selectedRepData = this.getDefaultModel();
        if (selectedRepData.length > 0) {
          // let defaultData = this.getDefaultModel();
          this.rows = selectedRepData;
        } else {
          this.rows = [];
          this.getinsertEmptyRows(this.rows, this.baselineData.gridSplitId);
        }
      }
      this.enableNonSuperResetButton(false, "reset");
    },
  },
};
</script>
<style lang="scss" module>
.adl-non-super {
  .cf-message-helper {
    margin-top: 5px !important;
  }
}
</style>
